'use client';

import { DatePlugin } from '@platejs/date/react';

import { DateElement } from '@/components/ui/date-node';

export const DateKit = [DatePlugin.withComponent(DateElement)];
